// document.addEventListener("DOMContentLoaded", function () {

//   // ===============================
//   // INIT SWIPER
//   // ===============================
//   const swiperHome = new Swiper(".banner_swiper", {
//     loop: true,
//     speed: 1000,
//     effect: "slide",
//     autoplay: {
//       delay: 5000,
//       disableOnInteraction: false,
//     },
//     pagination: {
//       el: ".banner_pagination",
//       clickable: true,
//     },
//   });

//   // ===============================
//   // ELEMENTS
//   // ===============================
//   const playBox = document.querySelector(".PlayBox");
//   let isPlaying = true;

//   // ===============================
//   // PAUSE / RESUME LOGIC
//   // ===============================
//   playBox.addEventListener("click", function () {

//     const activeBullet = document.querySelector(
//       ".HomeBanner .swiper-pagination-bullet-active::after"
//     );

//     if (isPlaying) {
//       // STOP SWIPER
//       swiperHome.autoplay.stop();

//       // PAUSE PROGRESS BAR
//       document
//         .querySelectorAll(".HomeBanner .swiper-pagination-bullet::after")
//         .forEach(() => {});

//       document.documentElement.style.setProperty(
//         "--swiper-play-state",
//         "paused"
//       );

//     } else {
//       // START SWIPER
//       swiperHome.autoplay.start();

//       // RESUME PROGRESS BAR
//       document.documentElement.style.setProperty(
//         "--swiper-play-state",
//         "running"
//       );
//     }

//     isPlaying = !isPlaying;
//   });

// });
(function () {
  "use strict";

  // ===============================
  // RUN WHEN IDLE (NON-BLOCKING)
  // ===============================
  function runWhenIdle(cb) {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(cb, { timeout: 2000 });
    } else {
      setTimeout(cb, 500);
    }
  }

  // ===============================
  // INIT AFTER LOAD (LCP SAFE)
  // ===============================
  window.addEventListener("load", function () {
    runWhenIdle(initHomeBannerSwiper);
  });

  // ===============================
  // INIT SWIPER
  // ===============================
  function initHomeBannerSwiper() {
    const bannerEl = document.querySelector(".banner_swiper");
    if (!bannerEl || typeof Swiper === "undefined") return;

    const swiperHome = new Swiper(bannerEl, {
      loop: true,
      speed: 1000,
      effect: "slide",

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },

      pagination: {
        el: ".banner_pagination",
        clickable: true,
      },
    });

    initPlayPause(swiperHome);
  }

  // ===============================
  // PLAY / PAUSE LOGIC
  // ===============================
  function initPlayPause(swiperHome) {
    const playBox = document.querySelector(".PlayBox");
    if (!playBox) return;

    let isPlaying = true;

    // initial state
    document.documentElement.style.setProperty(
      "--swiper-play-state",
      "running"
    );

    playBox.addEventListener("click", function () {
      if (isPlaying) {
        swiperHome.autoplay.stop();
        document.documentElement.style.setProperty(
          "--swiper-play-state",
          "paused"
        );
      } else {
        swiperHome.autoplay.start();
        document.documentElement.style.setProperty(
          "--swiper-play-state",
          "running"
        );
      }

      isPlaying = !isPlaying;
      playBox.classList.toggle("paused", !isPlaying);
    });
  }
})();

